<script setup lang="ts">
withDefaults(
  defineProps<{
    index: number | string,
    title?: string | null
  }>(),
  { title: null }
)
</script>

<template>
  <div class="rounded-[20px] bg-main-very-light-gray p-5">
    <div
      class="
        mb-3 w-min text-nowrap rounded-xl bg-main-gray-low px-3 py-2 text-sm font-medium leading-normal
        tracking-[-0.01em] text-main-blue md:mb-5 md:text-base
      "
    >
      {{ index }}
    </div>

    <strong
      v-if="title"
      class="mb-2 block text-lg font-medium leading-[1.22] text-main-dark md:mb-4 md:text-[22px] md:leading-[1.27]"
    >
      {{ title }}
    </strong>

    <slot />
  </div>
</template>
